// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--1sNjJ","links":"footer-module--links--1qz9I","copyrightLink":"footer-module--copyright-link--3oBhV"};